export default "<p>sms-services works!</p>\n";